<template>
    <header class="columns is-mobile" :class="{'no-border': noBorder}">
        <div class="column pl-0">
            <h1 class="mt-0" v-if="title">
                <i class="fad fa-fw mr-4" :class="icon"></i>{{ title }}
            </h1>
        </div>
        <div class="column is-narrow menu has-text-right pr-0 is-hidden-touch">
            <div class="pb-3">

                <router-link v-if="currentUser" :to="{name: 'account'}">
                    <b-tooltip label="User Settings" position="is-bottom">
                        {{ currentUser.first_name }} {{ currentUser.last_name }}
                    </b-tooltip>
                </router-link>


                <a v-if="currentUser && !close" :href="'https://www.my247ed.com/account/doAppLogin.php?u=' + currentUser.email + '&h=' + currentUser.legacy_hash" class="ml-5">
                    <b-tooltip label="Visit Legacy Site" position="is-bottom" class="has-text-weight-normal" style="font-size: 1rem;">
                        <i class="fad fa-arrow-up-right-from-square mr-3"></i>Legacy Site
                    </b-tooltip>
                </a>

                <a href="mailto:support@my247ed.com" class="ml-3">
                    <b-tooltip label="Get Help" position="is-bottom">
                        <i class="fas fa-circle-question"></i>
                    </b-tooltip>
                </a>
                <!--                    <b-tooltip label="Tasks" position="is-bottom" class="ml-4">-->
                <!--                        <i class="fad fa-list-check"></i>-->
                <!--                    </b-tooltip>-->
                <!--                    <b-tooltip label="Messages" position="is-bottom" class="ml-4">-->
                <!--                        <i class="fas fa-envelope"></i>-->
                <!--                    </b-tooltip>-->
                <!--                <router-link v-if="currentUser" :to="{name: 'account'}" class="ml-4">-->
                <!--                    <b-tooltip label="User Settings" position="is-bottom">-->
                <!--                        <i class="fad fa-user-cog"></i>-->
                <!--                    </b-tooltip>-->
                <!--                </router-link>-->

                <a @click="logout" class="ml-3">
                    <b-tooltip label="Logout" position="is-bottom">
                        <i class="fad fa-sign-out-alt"></i>
                    </b-tooltip>
                </a>

                <router-link :to="closeRoute" class="ml-5 pl-3" v-if="close" style="border-left: 1px solid rgba(255, 255, 255, 0.2)">
                    <b-tooltip :label="close" position="is-bottom">
                        <i class="fas fa-times"></i>
                    </b-tooltip>
                </router-link>
            </div>
        </div>

        <div class="column is-narrow is-inline-touch is-hidden-desktop">
            <b-dropdown aria-role="list" position="is-bottom-left">
                <template #trigger="{ active }">
                    <i class="fas fa-bars"></i>
                </template>

                <router-link :to="closeRoute" class="ml-5 pl-3" v-if="close" style="border-left: 1px solid rgba(255, 255, 255, 0.2)">
                    <b-dropdown-item class="is-size-5 mb-4"><i class="fad fa-fw fa-times ml-2 mr-2 has-text-primary"></i> {{ close }}</b-dropdown-item>
                </router-link>
                <a href="mailto:support@my247ed.com" class="ml-5">
                    <b-dropdown-item class="is-size-5 mb-3"><i class="fad fa-fw fa-circle-question ml-2 mr-2 has-text-primary"></i> Get Help</b-dropdown-item>
                </a>
                <router-link v-if="currentUser" :to="{name: 'account'}">
                    <b-dropdown-item class="is-size-5 mb-3"><i class="fad fa-fw fa-user-cog ml-2 mr-2 has-text-primary"></i> Account Settings</b-dropdown-item>
                </router-link>
                <a v-if="currentUser" :href="'https://www.my247ed.com/account/doAppLogin.php?u=' + currentUser.email + '&h=' + currentUser.legacy_hash">
                    <b-dropdown-item class="is-size-5 mb-3"><i class="fad fa-fw fa-arrow-up-right-from-square ml-2 mr-2 has-text-primary"></i> Visit Legacy Site</b-dropdown-item>
                </a>
                <a @click="logout">
                    <b-dropdown-item class="is-size-5 mb-4"><i class="fad fa-fw fa-sign-out-alt ml-2 mr-2 has-text-primary"></i> Logout</b-dropdown-item>
                </a>>
            </b-dropdown>
        </div>
    </header>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "MainHeader",
        props: {
            'title': {},
            'icon': {},
            'close': {},
            'closeRoute': {},
            'noBorder': {
                type: Boolean,
                default: false
            },
        },
        computed: {
            ...mapGetters(['currentUser']),
        },
        methods: {
            ...mapActions(['signOut']),
            logout: function() {
                this.signOut();
                this.$router.push({name: 'login'});
            }
        },
    };
</script>

<style lang="scss" scoped>
    header {
        padding: 0;
        margin: 0.657rem 0 2.5rem;
        color: rgba(255, 255, 255, 1);
        border-bottom: 1px dashed rgba(255, 255, 255, 0.2);

        &.no-border {
            border-bottom: none;
        }

        h1 {
            font-weight: 400;
            font-size: 22px;
            margin-top: 1.1rem;
            display: inline-block;
            cursor: pointer;

            strong {
                color: rgb(255, 255, 255);
            }

            i {
                vertical-align: middle;
                color: rgb(255, 255, 255);
            }

            @media (max-width: 768px) {
                margin-top: 1rem;
                font-size: 18px;
            }
        }

        .menu {
            margin-top: 0;
            color: rgb(255, 255, 255);
            font-weight: bold;

            i {
                margin-left: 1rem;
                cursor: pointer;
                font-size: 1.2rem;
                vertical-align: middle;

                &:hover {
                    color: white;
                }
            }

            a {
                color: white;
            }

            .user {
                @media (max-width: 1100px) {
                    display: none;
                }
            }


        }

        @media (max-width: 768px) {
            margin: 1.1rem 0 1rem;
        }
    }


</style>
